export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M2.5 12c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5-1.5.67-1.5 1.5m0-6c0 .83.67 1.5 1.5 1.5S5.5 6.83 5.5 6 4.83 4.5 4 4.5 2.5 5.17 2.5 6m.17 12c0 .73.6 1.33 1.33 1.33s1.33-.6 1.33-1.33a1.33 1.33 0 1 0-2.66 0M21 19v-2H7v2zm0-6v-2H7v2zM7 7h14V5H7z\"/>"
};